module.exports = __webpack_public_path__ + "img/48.6.CODm.6a93d71f.png";